export default "__VITE_ASSET__CIpc0H1v__"